import DataTable from "react-data-table-component";
import React, { useEffect, useRef, useState } from "react";
import { Col, Row, FormGroup, Label } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  getPayRates,
  getPayRatesType,
} from "../../redux/actions/api/apiAction";
import { Field } from "formik";
import deletenew from "../../assets/images/deletenew.svg";
export const PayrateForm = ({ setFieldValue, values }) => {
  const payRatesType = useSelector((state) => state.payRoll.payRatesType);
  const payRates = useSelector((state) => state.payRoll.payRates);
  const [payRatesSelected, setPayRatesSelected] = useState([]);
  const [payRatesRender, setPayRatesRender] = useState([]);
  const [selectedPayRateType, setSelectedPayRateType] = useState("");
  const [selectedPayRate, setSelectedPayRate] = useState("");
  const [isPayRatesSelected, setIsPayRatesSelected] = useState(false);
  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch(getPayRatesType());
  }, [dispatch]);
  const handlePayRateTypesChange = (e) => {
    console.log(e.target.value, "e.target.value");
    setSelectedPayRateType(e.target.value);
    dispatch(getPayRates(e.target.value));
  };
  const handlePayRateChange = async (e) => {
    const selectedId = parseInt(e.target.value, 10);
    setSelectedPayRate(e.target.value);

    if (!payRatesSelected) {
      setIsPayRatesSelected(false);
    }

    const selectedPayRate = payRates.find(
      (payRate) => payRate.id === selectedId
    );
    if (
      selectedPayRate &&
      !payRatesSelected.some((payRate) => payRate.id === selectedId)
    ) {
      setPayRatesSelected(() => {
        const updatedPayRatesSelected = [selectedPayRate];

        // Move the setFieldValue call inside this callback to ensure it uses updated state
        setFieldValue("payRates", updatedPayRatesSelected);
        return updatedPayRatesSelected; // This returns the new state
      });
    } else {
      console.log("Pay rate already selected or not found");
    }
  };
  // React.useEffect(() => {
  //   const allPayRates = new Set([...payRatesSelected, values.payRates]);
  //   setPayRatesRender(Array.from(allPayRates));

  //   if (payRatesSelected !== values.payRates) {
  //     setPayRatesSelected(values.payRates);
  //   }
  // }, [payRatesSelected, values.payRates && values.payRates]);
  return (
    <Row>
      <Col md={6}>
        <FormGroup className="custom-inputs">
          <Field
            onChange={handlePayRateTypesChange}
            // required={payRatesSelected.length < 1}
            value={selectedPayRateType}
            as="select"
            name="payratesType"
            id="payratesType"
            className={`form-control ${payRatesSelected.length < 1 &&
              isPayRatesSelected &&
              "is-invalid"}`}
          >
            <option value="">Select an option</option>
            {payRatesType.length &&
              payRatesType.map((type) => {
                return <option value={type.id}>{type.name}</option>;
              })}
          </Field>
          <Label>Main pay rate type</Label>
        </FormGroup>
      </Col>
      <Col md={6}>
        <FormGroup className="custom-inputs">
          <Field
            onChange={handlePayRateChange}
            required={payRatesSelected.length}
            value={selectedPayRate}
            as="select"
            name="payrate"
            id="payrate"
            className={`form-control ${payRatesSelected.length < 1 &&
              isPayRatesSelected &&
              "is-invalid"}`}
          >
            <option value="">Select an option</option>
            {payRates &&
              payRates.map((payRate) => {
                return (
                  <option value={payRate.id}>{payRate.payrateName}</option>
                );
              })}
          </Field>
          {payRatesSelected.length < 1 && isPayRatesSelected ? (
            <div className="invalid-feedback">
              Please select at least one pay rate
            </div>
          ) : null}
          <Label>Sub pay rate type</Label>
        </FormGroup>
      </Col>
      <Col md={6} className="mb-4 no-margin-on-mobile">
        <div className="d-flex flex-wrap" style={{ gap: "0.5rem" }}>
          {payRatesRender.length > 0 &&
            payRatesRender.map((payRate, i) => {
              return (
                <div
                  style={{
                    background: "#F6A51F",
                    borderRadius: "0.25rem",
                    display: "flex",
                    padding: "0.7rem 1rem",
                    color: "white",
                    gap: "1rem",
                  }}
                >
                  <p>{payRate.payrateName}</p>
                  <img
                    style={{ cursor: "pointer" }}
                    src={deletenew}
                    onClick={() => {
                      setPayRatesSelected(
                        payRatesSelected.filter((payRate, index) => index !== i)
                      );
                      setPayRatesRender(
                        payRatesRender.filter((payRate, index) => index !== i)
                      );
                      setFieldValue(
                        "payRates",
                        payRatesSelected.filter((payRate, index) => index !== i)
                      );
                    }}
                  />
                </div>
              );
            })}
        </div>
      </Col>
    </Row>
  );
};
